import { ArrowForwardIos } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React, { Children, cloneElement, isValidElement, useRef, useState, useCallback } from 'react';
import { Button } from "../button/index.js";
import { DropdownContainer } from "../dropdownContainer/DropdownContainer.js";
import { DropdownOptions } from "../dropdownWrapper/components/dropdownOptions/DropdownOptions.js";
import styles from "./SplitButton.module.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const SplitButton = ({
  label,
  children,
  secondary,
  disabled,
  className,
  onDropdownClick,
  outlined,
  small,
  appendDropdownTo,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const classes = classnames(styles.splitButton, secondary && styles.secondary, small && styles.small, outlined && styles.outlined, disabled && styles.disabled, className);
  const variant = outlined ? 'outlined' : undefined;
  const buttonProps = {
    disabled,
    secondary,
    small
  };
  function getChildren() {
    return Children.map(children, (child, index) => {
      if (/*#__PURE__*/isValidElement(child)) {
        const props = {
          small,
          onClick: () => {
            setOpen(false);
            if (onDropdownClick) {
              onDropdownClick(index);
            }
          }
        };
        return /*#__PURE__*/cloneElement(child, props);
      }
    }).filter(Boolean);
  }
  const handleSelect = index => {
    onDropdownClick?.(index);
    setOpen(false);
  };
  const handleDropDownState = e => {
    e.stopPropagation();
    setOpen(!open);
  };
  const handleMainClick = useCallback(e => {
    props.onClick?.(e);
    setOpen(false);
  }, [props]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      ref: ref,
      className: classes,
      children: [/*#__PURE__*/_jsx(Button, {
        variant: variant,
        ...buttonProps,
        ...props,
        // Typecast needed because of TS issues with variant union
        onClick: handleMainClick,
        children: label
      }), /*#__PURE__*/_jsx(Button, {
        variant: variant,
        className: styles.dropdownButton,
        ...buttonProps,
        onClick: handleDropDownState,
        noMinWidth: true,
        children: /*#__PURE__*/_jsx(ArrowForwardIos, {
          className: styles.icon,
          size: small ? 'SMALL' : 'DEFAULT'
        })
      })]
    }), /*#__PURE__*/_jsx(DropdownContainer, {
      onClickOutside: () => setOpen(false),
      visible: open,
      reference: ref,
      appendTo: appendDropdownTo,
      children: /*#__PURE__*/_jsx(DropdownOptions, {
        activeIndex: 0,
        onSelect: handleSelect,
        children: getChildren()
      })
    })]
  });
};